module.exports = {
	"articleTitle1": "Mezes brings authentic Greek cuisine to campus",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Cottage Inn",
	"articleLink1": "https://www.michigandaily.com/article/mezes-brings-authentic-greek-cuisine-campus",
	"articleLink2": "https://www.michigandaily.com/article/01same-same-different29",
	"articleSnippet1": "Oct 8, 2014 ... ... arrived in Ann Arbor at the age of 30, he opened Cottage Inn Pizza, ... to the 24\n-hour souvlaki restaurants after leaving bars in the early hours ...",
	"articleSnippet2": "Jan 28, 2013 ... He anticipates a lot of business to come from take-out and delivery because of ... \nWith NYPD, NeoPapalis, Cottage Inn and now Topper's, East ...",
	"foodRecommendations": [
		{
			"text": "Their gluten free cheese bread is addicting and Celiac friendly!",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "Pizza chain opens up in Ann Arbor",
	"address": "546 Packard St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.271985,
		"lng": -83.742141
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/cottageinntakeout.json
// module id = 856
// module chunks = 0